import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, RefreshCw, AlertTriangle } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking"); // checking | paid | error
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let active = true;
    const poll = async () => {
      if (!active) return;
      if (attempts.current >= 10) { setStatus("error"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refreshUser();
          setStatus("paid");
          toast.success("Abonnement activé ! 💪");
          setTimeout(() => nav("/app"), 1800);
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* retry */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-5">
      <div className="bg-card border border-border rounded-lg p-8 text-center max-w-md w-full" data-testid="payment-success-card">
        {status === "checking" && (<>
          <RefreshCw className="text-primary mx-auto mb-4 animate-spin" size={40} />
          <h1 className="font-display text-2xl mb-2">Validation du paiement…</h1>
          <p className="text-muted-foreground text-sm">Un instant, on active ton abonnement.</p>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 className="text-green-400 mx-auto mb-4" size={44} />
          <h1 className="font-display text-3xl mb-2">C'est validé !</h1>
          <p className="text-muted-foreground text-sm">Ton abonnement est actif. Redirection vers ton espace…</p>
        </>)}
        {status === "error" && (<>
          <AlertTriangle className="text-primary mx-auto mb-4" size={40} />
          <h1 className="font-display text-2xl mb-2">Paiement non confirmé</h1>
          <p className="text-muted-foreground text-sm mb-5">Nous n'avons pas pu confirmer le paiement. Si tu as été débité, contacte-nous.</p>
          <Button data-testid="payment-back-btn" onClick={() => nav("/pricing")} className="bg-primary hover:bg-primary/90 text-white rounded-md h-12 px-6 font-semibold">Retour aux tarifs</Button>
        </>)}
      </div>
    </div>
  );
}
